import { Injectable } from '@angular/core';
import { consultarProductosDTO, Producto } from '../models/producto.model';
import { Observable, of } from 'rxjs';
import { Categoria } from '../models/categoria.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import {
  ActualizarToppingDTO,
  CrearToppingDTO,
  Topping,
} from '../../pedidos/models/crearPedido.dto';

@Injectable({
  providedIn: 'root',
})
export class ProductosService {
  constructor(private _http: HttpClient) {}

  obtenerProductos(params?: consultarProductosDTO): Observable<Producto[]> {
    let httpParams = new HttpParams();

    if (params?.categoryId) {
      httpParams = httpParams.set('categoryId', params.categoryId);
    }

    if (params?.isAvailable !== undefined) {
      httpParams = httpParams.set('isAvailable', params.isAvailable);
    }

    if (params?.search) {
      httpParams = httpParams.set('search', params.search);
    }

    return this._http.get<Producto[]>(`${environment.urlApi}/products`, {
      params: httpParams,
    });
  }

  obtenerCategorias(): Observable<Categoria[]> {
    return this._http.get<Categoria[]>(`${environment.urlApi}/categories`);
  }

  crearCategoria(payload: { name: string; isActive: boolean }) {
    return this._http.post(`${environment.urlApi}/categories`, payload);
  }

  actualizarCategoria(
    id: number,
    payload: { name: string; isActive: boolean },
  ) {
    return this._http.put(`${environment.urlApi}/categories/${id}`, payload);
  }

  eliminarCategoria(id: number) {
    return this._http.delete(`${environment.urlApi}/categories/${id}`);
  }

  crearProducto(producto: any): Observable<any> {
    return this._http.post(`${environment.urlApi}/products`, producto);
  }

  actualizarProducto(id: number, producto: any) {
    return this._http.patch(`${environment.urlApi}/products/${id}`, producto);
  }

  eliminarProducto(id: number): Observable<any> {
    return this._http.delete(`${environment.urlApi}/products/${id}`);
  }

  subirImagen(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this._http.post<{ url: string }>(
      `${environment.urlApi}/upload`,
      formData,
    );
  }

  obtenerImagenProducto(id: number): Observable<Blob> {
    return this._http.get(`${environment.urlApi}/products/${id}/image`, {
      responseType: 'blob',
    });
  }

  obtenerToppings(params?: {
    isAvailable?: boolean;
    search?: string;
  }): Observable<Topping[]> {
    let httpParams = new HttpParams();

    if (params?.isAvailable !== undefined) {
      httpParams = httpParams.set('isAvailable', params.isAvailable);
    }

    if (params?.search) {
      httpParams = httpParams.set('search', params.search);
    }

    return this._http.get<Topping[]>(`${environment.urlApi}/toppings`, {
      params: httpParams,
    });
  }

  crearTopping(payload: CrearToppingDTO): Observable<Topping> {
    return this._http.post<Topping>(`${environment.urlApi}/toppings`, payload);
  }

  actualizarTopping(
    id: number,
    payload: ActualizarToppingDTO,
  ): Observable<Topping> {
    return this._http.put<Topping>(
      `${environment.urlApi}/toppings/${id}`,
      payload,
    );
  }

  eliminarTopping(id: number): Observable<void> {
    return this._http.delete<void>(`${environment.urlApi}/toppings/${id}`);
  }
}
